// src/App.jsx
import { useState } from "react";

export default function App() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Usuario:", username, "Contraseña:", password);
    // Aquí puedes agregar la lógica para autenticar contra tu backend
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-900 text-white">
      <h1 className="text-4xl font-bold mb-8">SII EXPRESS</h1>

      <div className="bg-gray-800 rounded-2xl shadow-lg p-8 w-80">
        <h2 className="text-lg font-semibold mb-6">Inicio de sesión</h2>

        <form onSubmit={handleSubmit} className="flex flex-col space-y-4">
          <div>
            <label className="block text-sm mb-1">Usuario</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full p-2 rounded-md bg-gray-700 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="usuario"
              required
            />
          </div>

          <div>
            <label className="block text-sm mb-1">Contraseña</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full p-2 rounded-md bg-gray-700 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="********"
              required
            />
          </div>

          <button
            type="submit"
            className="bg-white text-gray-900 font-semibold py-2 rounded-md hover:bg-gray-300 transition"
          >
            Ingresar
          </button>
        </form>

        <div className="mt-4 text-center text-sm text-blue-400 cursor-pointer hover:underline">
          Recuperar contraseña
        </div>

        <hr className="my-4 border-gray-600" />

        <button className="w-full border border-gray-400 py-2 rounded-md hover:bg-gray-700 transition">
          Registrar cuenta
        </button>
      </div>
    </div>
  );
}
